import Icon from '../../../components/AppIcon';


const ActivityItem = ({ type, title, description, timestamp, avatar, avatarAlt, priority }) => {
  const typeConfig = {
    application: { icon: 'FileText', color: 'text-primary', bg: 'bg-primary/10' },
    message: { icon: 'MessageSquare', color: 'text-accent', bg: 'bg-accent/10' },
    job: { icon: 'Briefcase', color: 'text-success', bg: 'bg-success/10' },
    payment: { icon: 'DollarSign', color: 'text-warning', bg: 'bg-warning/10' }
  };

  const config = typeConfig?.[type] || typeConfig?.application;

  const formatTimestamp = (date) => {
    const now = new Date();
    const diff = now - new Date(date);
    const minutes = Math.floor(diff / 60000);
    const hours = Math.floor(diff / 3600000);
    const days = Math.floor(diff / 86400000);

    if (minutes < 60) return `${minutes}m ago`;
    if (hours < 24) return `${hours}h ago`;
    return `${days}d ago`;
  };

  const getIcon = () => {
    switch (type) {
      case 'application':
        return <Icon name="FileText" size={16} className="text-blue-600" />;
      case 'message':
        return <Icon name="MessageSquare" size={16} className="text-[#FF6A00]" />;
      case 'job':
        return <Icon name="Briefcase" size={16} className="text-gray-600" />;
      case 'payment':
        return <Icon name="DollarSign" size={16} className="text-[#D4AF37]" />;
      default:
        return <Icon name="Bell" size={16} className="text-gray-600" />;
    }
  };

  return (
    <div className="flex items-start gap-2 md:gap-3 p-2 md:p-3 rounded-md hover:bg-muted/50 transition-smooth">
      <div className={`w-7 h-7 md:w-10 md:h-10 rounded-full flex items-center justify-center flex-shrink-0 ${
        priority === 'high' ? 'bg-destructive/10 text-destructive' :
        priority === 'medium'? 'bg-warning/10 text-warning' : 'bg-primary/10 text-primary'
      }`}>
        <Icon name={getIcon()} size={14} className="md:w-5 md:h-5" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-xs md:text-sm font-medium text-foreground mb-0.5 md:mb-1 line-clamp-1">
          {title}
        </p>
        <p className="text-[10px] md:text-xs text-muted-foreground line-clamp-2">
          {description}
        </p>
        <p className="text-[10px] md:text-xs text-muted-foreground mt-0.5 md:mt-1">
          {formatTimestamp(timestamp)}
        </p>
      </div>
    </div>
  );
};

export default ActivityItem;